import { buildAction } from 'store/actions/actionCreator'

import { FETCH_CHANNELS } from './constants'

export const fetchChannels = buildAction(FETCH_CHANNELS, 'payload')
